import { Skeleton, Typography } from '@mui/material';
import { useLocalization } from 'localization';

type Props = {
  loading: boolean;
  text: string;
  additionalText?: { [key: string]: string | number };
};

const LoadingText = (props: Props) => {
  const { loading = false, text, additionalText = {} } = props;
  const { t } = useLocalization();
  return loading ? (
    <Skeleton variant="rounded" sx={{ borderRadius: '0.5rem' }} />
  ) : (
    <Typography variant="h6">{t(text, additionalText)}</Typography>
  );
};

export default LoadingText;
